// src/Components/BCM_Norms/FilterManager.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import FilterModal from './FilterModal';

const styles = {
    managerBackdrop: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    managerContainer: { backgroundColor: 'white', padding: '25px', borderRadius: '12px', width: '90%', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px' },
    title: { margin: 0, fontSize: '1.5rem', fontWeight: 700 },
    button: { background: '#1a73e8', color: 'white', border: 'none', padding: '10px 14px', borderRadius: '8px', cursor: 'pointer', fontWeight: 700 },
    closeButton: { background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer' },
    filterList: { marginTop: '20px', listStyle: 'none', padding: 0 },
    filterItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '10px' },
    filterName: { fontWeight: 600 },
    actions: { display: 'flex', gap: '10px' },
    actionButton: { background: '#f1f5f9', border: '1px solid #d1d5db', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer' },
    deleteButton: { color: '#ef4444', borderColor: '#fecaca', background: '#fef2f2' },
};

const FilterManager = ({ isOpen, onClose, onFiltersUpdate }) => {
    const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingFilter, setEditingFilter] = useState(null);

    const fetchFilters = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get('/bcm_norms/filters/');
            setFilters(response.data);
        } catch (err) { setError('Could not fetch filters.') }
        finally { setLoading(false) }
    }, []);

    useEffect(() => { if (isOpen) { fetchFilters() } }, [isOpen, fetchFilters]);

    const handleCreate = () => { setEditingFilter(null); setIsModalOpen(true) };
    const handleEdit = (filter) => { setEditingFilter(filter); setIsModalOpen(true) };
    const handleDelete = async (filterId) => {
        if (window.confirm('Are you sure you want to delete this filter?')) {
            try {
                await api.delete(`/bcm_norms/filters/${filterId}/`);
                const updatedFilters = filters.filter(f => f.id !== filterId);
                setFilters(updatedFilters);
                onFiltersUpdate(updatedFilters);
            } catch (err) { alert('Failed to delete filter.') }
        }
    };
    const handleSave = (savedFilter) => {
        const existing = filters.find(f => f.id === savedFilter.id);
        let updatedFilters = existing ? filters.map(f => f.id === savedFilter.id ? savedFilter : f) : [...filters, savedFilter];
        setFilters(updatedFilters);
        onFiltersUpdate(updatedFilters);
        setIsModalOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div style={styles.managerBackdrop} onClick={onClose}>
            <div style={styles.managerContainer} onClick={e => e.stopPropagation()}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Manage Filters</h2>
                    <button onClick={onClose} style={styles.closeButton}>&times;</button>
                </div>
                <div style={{ padding: '20px 0' }}>
                    <button style={styles.button} onClick={handleCreate}>+ Create New Filter</button>
                </div>
                {loading && <p>Loading filters...</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {!loading && !error && (
                    <ul style={styles.filterList}>
                        {filters.map(filter => (
                            <li key={filter.id} style={styles.filterItem}>
                                <span style={styles.filterName}>{filter.name}</span>
                                <div style={styles.actions}>
                                    <button style={styles.actionButton} onClick={() => handleEdit(filter)}>Edit</button>
                                    <button style={{...styles.actionButton, ...styles.deleteButton}} onClick={() => handleDelete(filter.id)}>Delete</button>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                {isModalOpen && <FilterModal onClose={() => setIsModalOpen(false)} onSave={handleSave} existingFilter={editingFilter} />}
            </div>
        </div>
    );
};

export default FilterManager;